<template>
  <div>
    <!-- 悬浮图标 -->
    <div 
      class="floating-icon"
      :class="{ 'floating-icon--visible': visible }"
      :style="floatingStyle"
      @click="handleClick"
    >
      <slot>
        <!-- 默认图标内容，可以通过插槽自定义 -->
        <i class="el-icon-message"></i>
      </slot>
    </div>

    <!-- 添加留言弹窗 -->
    <m-dialog
      title="请输入留言内容"
      :visble.sync="addBialogVisible"
      width="600px"
      append-to-body
      destroy-on-close
    >
      <el-form
        :rules="addRules"
        :model="addFrom"
        ref="addFrom"
        status-icon
        label-position="top"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addFrom.name" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="所属部门" prop="department">
          <el-input
            v-model="addFrom.department"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>

        <el-form-item label="职务" prop="title">
          <el-input v-model="addFrom.title" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="addFrom.phone" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="留言内容" prop="comment">
          <el-input
            type="textarea"
            v-model="addFrom.comment"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>

        <div class="dialog-footer">
          <el-button @click="addBialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmitForm('addFrom')"
            >确 定</el-button
          >
        </div>
      </el-form>
    </m-dialog>
  </div>
</template>

<script>
import MessageCenter from "@/api/messageCenter.js";

export default {
  name: "FloatingIcon",
  props: {
    // 是否显示悬浮图标
    visible: {
      type: Boolean,
      default: true
    },
    // 距离右边的距离
    right: {
      type: String,
      default: "20px"
    },
    // 距离底部的距离
    bottom: {
      type: String,
      default: "20px"
    },
    // 层级
    zIndex: {
      type: Number,
      default: 1000
    },
    // 是否显示留言功能
    showMessage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // 留言弹窗相关数据
      addBialogVisible: false,
      addFrom: {
        id: "", // 主键 ID，UUID 格式
        name: "", // 姓名
        department: "", // 所属部门
        title: "", // 职务头衔
        phone: "", // 联系电话
        comment: "", // 留言内容
        checkStatus: 0, // 审核状态：0-未审核，1-已审核，2-驳回等
        delStatus: 0, // 逻辑删除：0-未删除，1-已删除
        handleComment: "" //处理内容
      },
      addRules: {
        name: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ],
        department: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的11位手机号" }
        ],
        comment: [
          {
            required: true,
            message: "必须填写",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    floatingStyle() {
      return {
        right: this.right,
        bottom: this.bottom,
        zIndex: this.zIndex
      };
    }
  },
  methods: {
    handleClick() {
      if (this.showMessage) {
        // 如果启用留言功能，点击打开留言弹窗
        this.PopUp();
      }
      // 触发自定义点击事件
      this.$emit('click');
    },
    // 留言弹窗
    PopUp() {
      this.addBialogVisible = true;
    },
    // 留言提交
    addSubmitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            name: this.addFrom.name, // 姓名
            department: this.addFrom.department, // 所属部门
            title: this.addFrom.title, // 职务/头衔
            phone: this.addFrom.phone, // 联系电话
            comment: this.addFrom.comment, // 留言内容
            checkStatus: 0, // 审核状态：0-未审核，1-已审核，2-驳回等
            delStatus: 0 // 逻辑删除：0-未删除，1-已删除
          };
          const { code, msg, data } = await MessageCenter.addOrUpDateList(
            params
          );
          if (code === 200) {
            this.$message({
              message: msg,
              type: "success"
            });
            // 重置表单
            this.resetForm();
            this.addBialogVisible = false;
          } else {
            this.$message.error(msg);
          }
        } else {
          return false;
        }
      });
    },
    // 重置表单
    resetForm() {
      this.addFrom = {
        id: "", // 主键 ID，UUID 格式
        name: "", // 姓名
        department: "", // 所属部门
        title: "", // 职务头衔
        phone: "", // 联系电话
        comment: "", // 留言内容
        checkStatus: 0, // 审核状态：0-未审核，1-已审核，2-驳回等
        delStatus: 0, // 逻辑删除：0-未删除，1-已删除
        handleComment: "" //处理内容
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.floating-icon {
  position: fixed;
  width: 94px;
  height: 94px;
  background: #FFFFFF;
  box-shadow: 0px 3px 8px 0px rgba(29, 126, 41, 0.24);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20px);

  // 图标样式
  i {
    font-size: 24px;
    color: #1D7E29;
  }

  // 悬停效果
  &:hover {
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0px 6px 16px 0px rgba(29, 126, 41, 0.32);
  }

  // 激活状态
  &:active {
    transform: translateY(0px) scale(0.98);
  }

  // 显示状态
  &--visible {
    opacity: 1;
    transform: translateY(0);
  }
}

// 动画效果
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
}

.floating-icon--visible:hover {
  animation: float 2s ease-in-out infinite;
}

// 弹窗样式
.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style> 


// WEBPACK FOOTER //
// src/components/floatingIcon/index.vue